module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2926c32b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/settings.vue
// module id = 556
// module chunks = 0